import { ReactNode } from 'react';

import { tailint } from '@pukka/common/utils';
import { twMerge } from 'tailwind-merge';

const sizes = tailint({
  xxl: 'h-10 w-52 rounded-lg',
  lg: 'my-0.5 h-7 w-48',
  md: 'mb-1 mt-0.5 h-5 w-48',
  sm: 'my-0.5 h-4 w-20',
});

interface ShimmerProps {
  readonly size?: keyof typeof sizes;
  readonly animation?: boolean;
  readonly children?: ReactNode;
  readonly className?: string;
}

function Shimmer({ animation = true, size, children, className }: ShimmerProps) {
  return (
    <div role="status" aria-busy="true" className={twMerge('shimmer', animation && 'animate-shimmer', size && sizes[size], className)}>
      {children}
    </div>
  );
}

export { Shimmer };
